import { Icon } from '@/components/Icon'
import { RawButton } from '@/components/Button'
import styles from './TxfButton.module.css'

export interface TxfButtonProps {
  onPress: () => unknown
}

/**
 * TXF is the one AI-assisted action on the job, so it carries the spark.
 */
export function TxfButton({ onPress }: TxfButtonProps) {
  return (
    <RawButton
      className={styles.root}
      onPress={onPress}
      testId="export-to-txf-button"
    >
      <Icon
        name="sparkle"
        size={12}
        color="var(--color-light-violet)"
        aria-hidden="true"
      />
      Review &amp; export to TXF
    </RawButton>
  )
}
